import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import moment from 'moment';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';
import { getCurrentMatches } from '../utils/matches';

export const useCurrentMatchesTeam = (abbrv) => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/team/current-matches?id=${abbrv}`)
      .then((response) => {
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [abbrv, endpointUrl, setData]);

  return [data, loading, error];
};

export const useCurrentMatches = () => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/current-matches`)
      .then((response) => {
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  const matches = data && !loading ? getCurrentMatches(data, 5, 5) : [];

  return [matches, loading, error];
};

export const useMatchesMinimized = (season) => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/match-list/minimized?season=${season}`)
      .then((response) => {
        setIsLoading(true);
        setData(null);
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData, season]);

  return [data, loading, error];
};

export const useMatches = () => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/team/match-list`)
      .then((response) => {
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  return [data, loading, error];
};

export const useMatchesToday = () => {
  const { currentSeason } = useContext(DataContext);
  const [matches, loading, error] = useMatchesMinimized(currentSeason);

  const matchesToday =
    matches && !loading
      ? matches.filter((match) =>
          moment(match.startDate).isSame(moment(), 'day')
        )
      : [];

  return [matchesToday, loading, error];
};
